import 'bootstrap-sass/assets/javascripts/bootstrap/modal';
import Cookies from '../utilities/Cookies';
import Component from '../site/Component';
import Analytics from './Analtyics';

/**
 * Component for GDPR notice
 */
export default class Notice extends Component {
  /**
   * Start the component (called when Component is instantiated)
   */
  start() {
    this.cookie = new Cookies();
    this.analytics = new Analytics();
    this.executeScripts();
  }

  /**
   * Allow site cookies and execute scripts by setting them here.
   */
  executeScripts() {
    /* Run newsletter pop up */
    this.newsletterPopUp();
    /* Initiate Google Tag Manager */
    this.analytics.gtm();
    /* Initiate Facebook */
    this.facebookInit();
    if(! this.cookie.getCookie('cookie__privacy_policy')) {
      $('#privacy_collapse').show();
      this.privacyPolicyOptInOut();
    }
    /* Allow iframes, which may use cookies. */
    Notice.iframesInit();
  }

  /**
   * Set the Newsletter popup modal cookie and show pop up if needed
   */
  newsletterPopUp() {
    if (! this.cookie.getCookie('cookie__newsletter_popup')) {
      this.cookie.setCookie('cookie__newsletter_popup', 'next', 90);
    } else if ('next' === this.cookie.getCookie('cookie__newsletter_popup')) {
      this.cookie.setCookie('cookie__newsletter_popup', 'seen', 90);
      window.setTimeout(() => $('#newsletter_popup').modal('show'), 5000);
    }
  }

  /**
   * Privacy policy opt in and out
   */
  privacyPolicyOptInOut() {
    $('#sdk-overlay').show();
    const optIn = document.querySelector('#privacyOptInOut #optIn');
    const optOut = document.querySelector('#privacyOptInOut #optOut');
    const close = document.querySelector('#closePrivacyOptInOut');
    if (optIn) {
      optIn.addEventListener('click', () => {
        this.privacyPolicy(true);
        this.closePrivacyPolicy();
        $('#privacy_collapse').hide();
        $('#sdk-overlay').hide();
      });
    }
    if (optOut) {
      optOut.addEventListener('click', () => {
        this.privacyPolicy(false);
        this.closePrivacyPolicy();
        $('#sdk-overlay').hide();
      });
    }
    if (close) {
      close.addEventListener('click', () => {
        this.privacyPolicy(false);
        this.closePrivacyPolicy();
        $('#sdk-overlay').hide();
      });
    }
  }

  /**
   * Set the Privacy Policy modal cookie and show pop up if needed. Not being
   * called, but left here for future use.
   */
  privacyPolicy( optIn = false ) {
    if (optIn) {
      this.cookie.setCookie('cookie__privacy_policy', 'next', 3000);
      $('#privacy_collapse').show();
      return 'cookie__privacy_policy next';
    }
    this.cookie.setCookie('cookie__privacy_policy', 'seen', 90);
    $('#privacy_collapse').hide();
    return 'cookie__privacy_policy seen';
  }

  /**
   * Collapse Privacy Policy.
   */
  closePrivacyPolicy() {
    const closeBtn = document.querySelector(this.elements.button);
    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        $('#privacy_collapse').hide();
      });
    }
  }

  /**
   * Enable all iframes.
   */
  static iframesInit() {
    const iframes = document.getElementsByTagName('iframe');
    Array.prototype.forEach.call(iframes, (x) => {
      // Set the src attribute
      if (x.dataset.src && ! x.src) {
        x.setAttribute('src', x.dataset.src);
      }
      // Remove the wrapper class and add the loaded class.
      const prefix = 'hachette-iframe';
      const parentEl = x.parentElement;
      if (parentEl && parentEl.classList.contains(`${prefix}-pending`)) {
        parentEl.classList
          .replace(`${prefix}-pending`, `${prefix}-loaded`);
      }
    });
  }

  /**
   * If user has appended ?revoke-gdpr-permissions=true
   * to the URL, then delete all the cookies.
   */
  maybeRevokeConsent() {
    const url = new URL(window.location);
    if (url.searchParams && url.searchParams.get('revoke-gdpr-permissions')) {
      if (document.cookie) {
        const cookies = document.cookie.split('; ');
        Array.prototype.forEach.call(cookies, (x) => {
          const parts = x.split('=');
          if (parts[0]) {
            this.cookie.deleteCookie(parts[0]);
          }
        });
      }
    }
  }

  facebookInit() { // eslint-disable-line class-methods-use-this
    /* eslint-disable */
    // load facebook sdk for like / share buttons
    (function loadFacebookSDK(dd, ss, id) {
      let js = dd.getElementsByTagName(ss)[0];
      const fjs = dd.getElementsByTagName(ss)[0];
      if (dd.getElementById(id)) return;
      js = dd.createElement(ss); js.id = id;
      js.src = '//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.9';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
    /* eslint-enable */
  }
}